import PropTypes from 'prop-types';

export default function Badge({ name }) {
	return <span className="badge">{name}</span>;
}

Badge.propTypes = {
	name: PropTypes.string.isRequired,
};
